import React from 'react';

import { Edit } from 'lucide-react';
import { FaArrowLeftLong } from 'react-icons/fa6';
import UseBillingInfo from './UseBillingInfo';
import { Link } from 'react-router-dom';
import { AiOutlineHome } from 'react-icons/ai';
import { FaChevronRight } from 'react-icons/fa6';
import { FaPlus } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import { RxCross2 } from 'react-icons/rx';
import SelectAddressModal from './Components/SelectAddressModal';
import { LuRefreshCcw } from 'react-icons/lu';
import SuccessModal from './Components/SuccessModal';
import config from '../../../../config/environment';
import 'react-datepicker/dist/react-datepicker.css';
import { addDays } from 'date-fns';
import DatePicker from 'react-datepicker';
const SERVER_URL = config.SERVER_URL;

const BillingInfoPage: React.FC = () => {
  const { states, handlePlaceOrder, handleSelectAddress, openSelectAddressModal, navigate } = UseBillingInfo();
  return (
    <>
      <div>
        <div className=' bg-[#F5F5F5] py-8 px-4 hidden sm:hidden md:hidden lg:block xl:block'>
          <nav className='flex items-center text-base gap-2 mx-[10%]'>
            <Link to='/home'>
              <AiOutlineHome className='text-black font-semibold size-6 cursor-pointer hover:text-[#4A2D1A]' />
            </Link>
            <FaChevronRight className='text-black font-semibold size-3' />
            <Link to='/product/cart'>
              <span className='text-black text-base font-poppins'>My Shopping Cart</span>
            </Link>
            <FaChevronRight className='text-black font-semibold size-3' />
            <span className='text-base font-rubik text-orange-950'>Billing Information</span>
          </nav>
        </div>

        <div className='flex items-center justify-center my-2 sm:my-2 md:my-2 lg:my-4 '>
          <div className='mx-[.5%] sm:mx-[.5%] md:mx-[1%] lg:mx-[10%] py-4'>
            <div className='block sm:block md:hidden lg:hidden'>
              <div className='sm:hidden px-4 pb-4 text-lg font-semibold flex items-center'>
                <FaArrowLeftLong onClick={() => navigate(-1)} className='mr-3' />
                Billing Information
              </div>
              <div className='block sm:hidden px-4'>
                <Link to='/user/create-address'>
                  <div className='border border-[#C12E2A] text-[#C12E2A] font-semibold px-4 py-2 rounded-lg flex items-center text-sm'>
                    <FaPlus className='mr-2' />
                    Add New Address
                  </div>
                </Link>
              </div>
            </div>
            <div className='hidden sm:hidden md:block lg:block'>
              <h2 className=' text-xl sm:text-xl md:text-2xl lg:text-3xl font-bold text-[#4A2D1A] mb-2 flex items-center justify-center font-rubik'>
                BILLING INFORMATION
              </h2>
            </div>

            <div className='flex flex-col lg:flex-row items-start justify-center gap-4 p-4'>
              {/* LEFT SIDE - Address Section */}
              <div className='flex-1   bg-white rounded-lg shadow-md sm:shadow-none p-4 border'>
                <div className='hidden sm:hidden md:block lg:block'>
                  <div className='flex justify-between items-center mb-6 border-b pb-4'>
                    <h2 className='text-xl font-medium text-black font-poppins hidden sm:block'>Address</h2>
                    <Link to='/user/create-address'>
                      <button className='flex items-center bg-white hover:bg-[#4A2D1A] text-base text-[#4A2D1A] hover:text-white px-4 py-1 font-medium rounded-lg font-poppins'>
                        <FiPlus className='text-lg' /> &nbsp;&nbsp;Add New Address
                      </button>
                    </Link>
                  </div>
                </div>

                <div className='border rounded-lg p-4 mb-4 relative transition-all font-poppins'>
                  <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 items-start'>
                    {/* Left Column */}
                    <div>
                      <h3 className='text-sm sm:text-sm md:text-base lg:text-base font-semibold text-gray-500 mb-4 uppercase font-poppins border-b-2 md:border-b-0 pb-2'>
                        SHIPPING ADDRESS
                      </h3>
                      {states.shippingAddresses && (
                        <>
                          <div className='text-sm sm:text-sm md:text-base lg:text-base pb-2 font-poppins'>
                            {states.shippingAddresses?.contacts?.[0]?.name || 'N/A'}
                          </div>
                          <div className='text-sm text-gray-600 font-poppins pb-2'>
                            {states.shippingAddresses?.address_line1}, {states.shippingAddresses?.address_line2},{' '}
                            {states.shippingAddresses?.city}, {states.shippingAddresses?.state}-
                            {states.shippingAddresses?.pincode}
                          </div>
                          <div className='flex flex-col gap-2 mt-2 text-xs font-poppins pb-2'>
                            <div className='flex flex-col'>
                              <span className='text-xs text-gray-500'>Email</span>
                              <span className='text-sm '>
                                {' '}
                                {states.shippingAddresses?.contacts?.[0]?.email_id || '-'}
                              </span>
                            </div>
                            <div className='flex flex-col'>
                              <span className='text-xs  text-gray-500'>Phone</span>
                              <span className='text-sm'>
                                {' '}
                                {states.shippingAddresses?.contacts?.[0]?.mobile_no || '-'}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {/* Right Column (Edit/Delete buttons) */}
                    <div className='flex justify-end items-start gap-2 absolute top-5 right-4'>
                      <LuRefreshCcw
                        onClick={() =>
                          openSelectAddressModal(
                            states.shippingAddresses?.name ? states.shippingAddresses?.name : null,
                            'Shipping'
                          )
                        }
                        className='w-4 h-4 sm:w-4 sm:h-4 md:w-6 md:h-6 lg:w-6 lg:h-6 text-gray-600 hover:text-[#4A2D1A]'
                      />
                      {states.shippingAddresses && (
                        <>
                          <Link to={`/user/edit-address/${states.shippingAddresses?.name}`}>
                            <Edit className='w-4 h-4 sm:w-4 sm:h-4 md:w-6 md:h-6 lg:w-6 lg:h-6 text-gray-600 hover:text-[#4A2D1A]' />
                          </Link>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT SIDE - Order Summary  Delivery Date Picker*/}
              <div className='w-full lg:w-1/4'>
                <div className='bg-white rounded-lg shadow-sm py-3 px-4 border'>
                  <h3 className='text-lg font-semibold mb-1'>Delivery Date</h3>
                  <DatePicker
                    selected={states.selectedDate}
                    onChange={date => {
                      // states.setSelectedDate(date);
                      states.selectedDeliveryDate(date);
                    }}
                    dateFormat='yyyy-MM-dd'
                    minDate={new Date()}
                    maxDate={addDays(new Date(), 45)}
                    className='w-[100%] border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-xs md:text-sm lg:text-sm'
                    placeholderText='Choose your delivery date'
                  />
                  {states.error && <p className='text-red-500 text-sm mt-1'>{states.error}</p>}
                  <p className='text-gray-400 text-xs mt-2'>Delivery time between 9:00 AM to 8:00 PM</p>
                  {/* <p className='text-gray-400 text-xs mt-1'>Delivery Time: 9 AM – 8 PM</p> */}
                </div>

                {/* Order Summary */}
                <div className='bg-white rounded-lg shadow-sm p-4 border mt-2'>
                  <h3 className='text-lg font-semibold mb-1'>Order Summary</h3>
                  {states.productsList.map(product => (
                    <div key={product.id} className='flex justify-between items-center mb-2'>
                      <div className='flex items-center gap-3 mr-1'>
                        <img
                          src={`${SERVER_URL}${product.web_item_name?.thumbnail}`}
                          alt='--'
                          className='w-12 h-12 rounded-md object-cover'
                        />
                        <div className='flex flex-col'>
                          <span className='text-sm text-gray-900 font-poppins'>
                            {product?.web_item_name?.web_item_name}
                          </span>
                          <span className='text-xs text-gray-500 flex items-center font-poppins'>
                            {product?.qty} <RxCross2 /> {product?.website_item}
                          </span>
                        </div>
                      </div>
                      <span className='text-sm text-black font-normal font-poppins'>
                        ₹{product.tax_amount ? Number(product.tax_amount.toFixed(2)) : '00.00'}
                      </span>
                    </div>
                  ))}

                  <div className='text-sm text-gray-700 font-poppins'>
                    <div className='flex justify-between border-b pb-3 pt-1'>
                      <span>Shipping:</span>
                      <span className='text-green-800 font-poppins'>Free</span>
                    </div>
                    <div className='flex justify-between font-medium py-2'>
                      <span>Total:</span>
                      <span className='text-gray-900 font-poppins'>
                        ₹
                        {states.cartDataArr?.grand_total ? Number(states.cartDataArr?.grand_total).toFixed(2) : '00:00'}
                      </span>
                    </div>
                  </div>

                  {/* Payment */}
                  <div className='mt-1'>
                    <p className='text-sm font-semibold mb-2 font-poppins'>Payment Method</p>
                    <div className='space-y-2'>
                      <label className='flex items-center gap-2 cursor-pointer text-sm text-gray-700'>
                        <input type='radio' name='payment' className='peer hidden' defaultChecked />
                        <div className='w-4 h-4 border-2 border-[#C12E2A] rounded-full peer-checked:bg-[#C12E2A] peer-checked:border-gray-300 transition-colors font-poppins'></div>
                        Cash on Delivery
                      </label>
                    </div>
                  </div>

                  <button
                    onClick={handlePlaceOrder}
                    className='mt-5 w-full bg-red-700 hover:bg-red-800 text-white py-2 rounded-lg font-semibold transition font-poppins'
                  >
                    Place Order ({states.productsList.length} items)
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {states.isOpenSelectAddressModal && (
        <SelectAddressModal
          addressDataArr={states.addressDataArr}
          selectedAddress={states.selectedBillingShippingAddress}
          handleSelectAddress={handleSelectAddress}
          setIsOpenSelectAddressModal={states.setIsOpenSelectAddressModal}
        />
      )}

      {states.placedOrderId && states.placedOrderId !== '' && states.placedOrderId !== null && (
        <SuccessModal orderId={states.placedOrderId} />
      )}
    </>
  );
};

export default BillingInfoPage;
